// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__32m2B","title":"Info_title__1GXRB","links":"Info_links__3z-lY","link":"Info_link__13GDE","logo":"Info_logo__37f2M"};